import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
	selector: 'app-view-error-log',
	standalone: false,
	templateUrl: './view-error-log.component.html',
	styleUrl: './view-error-log.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewErrorLogComponent {

	logControl = new FormControl();
	logCopied = false;

	private log: string;

	constructor(
		@Inject(DIALOG_DATA) public readonly data: { log: string },
		private readonly dialogRef: DialogRef<boolean>,
        private readonly cdRef: ChangeDetectorRef
	) {
		this.log = this.data.log;
		this.logControl.patchValue(this.parseLog(this.data.log));
	}

	close(): void {
		this.dialogRef.close(false);
	}

	copy(): void {
		try {
			navigator.clipboard.writeText(this.log).then(() => {
				this.logCopied = true;
				this.cdRef.markForCheck();
			})
		} catch (err) {
			console.error('Failed to copy text:', err);
			this.logCopied = false;
		}
	}

	private parseLog(log: string): string {
		try {
			const parsed = JSON.parse(log);
			return this.parseToString(parsed);
		} catch (e) {
			return log;
		}
	}

	private parseToString(data: Record<string, any>): string {
		let parsedString = '';
		for (const key in data) {
			parsedString += key + ': ' + data[key] + '\n';
		}
		return parsedString;
	}

}
